<template>
  <transition name="tag-hash">
    <div
      v-if="filteredTag.length"
      class="tag-hash__container"
      :data-qa="dataQa">
      <div
        v-if="tabs && tabs.length > 1"
        class="tag-hash__tabs"
        :data-qa="`${dataQa}-tabs`">
        <span
          v-for="typeItem in tabs"
          :key="`hast-tab-${typeItem.key}`"
          class="tag-hash__tab"
          :class="{'active': type===typeItem.key}"
          :data-qa="`${dataQa}-tab-${typeItem.key}`"
          @click="changeType(typeItem)">{{ typeItem.label | firstUpperCase }}</span>
      </div>
      <div :class="{'tag-hash__items' : tabs && tabs.length}">
        <div
          v-for="(item, index) in filteredTag"
          :key="`tag-item-${index}`"
          class="hash-tag"
          :class="{'active': index === activeItem}"
          :data-qa="`${dataQa}-tab-hash`"
          @click.prevent.stop="$emit('select-hash-tag', item)"
          @mouseover="activeItem = index">
          <div
            class="hash-tag__name"
            :data-qa="`${dataQa}-tab-${item.type}`">
            <b v-if="item.type==='tender'">#</b>
            <b :data-qa="`${dataQa}-tab-hash-number`">{{ item.number }}</b>
            <span
              class="ml-4"
              :data-qa="`${dataQa}-tab-hash-title`"
              style="white-space: break-spaces;">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { componentOptions} from 'mixins'

export default {
  name: 'tagHash',
  mixins: [ componentOptions],
  props: {
    filteredTag: {
      type: Array,
      required: true
    },
    selectItem: {
      type: Boolean,
      default: null
    },
    activeUpOrDown: {
      type: Number,
      default: null
    },
    activeLeftOrRight: {
      type: Number,
      default: null
    },
    type: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'tag-hash'
    }
  },
  emits: ['select-hash-tag', 'activate-item'],
  data() {
    return {
      activeItem: 0,
      hashTypes: [
        {
          key: 'lot',
          hash: '#',
          label: this.$t('Tenders.Leads'),
          sort: 0
        },
        {
          key: 'bid',
          hash: '##',
          label: this.$t('Tenders.Offers'),
          sort: 1
        },
        {
          key: 'tender',
          hash: '###',
          label: this.$t('Tenders.Tenders'),
          sort: 2
        },
      ],
      mutableOptions: {
        tender: true,
        lot: true,
        bid: true,
      },
    }
  },
  methods: {
    changeType(type) {
      this.$emit('changeType', type)
    }
  },
  computed: {
    tabs() {
      return this.hashTypes.map(i => ({
        ...i,
        show: this.mutableOptions[i.key]
      })).filter(i => i.show)
    },
  },
  watch: {
    filteredTag(val, oldVal) {
      if (!oldVal.length || val.length !== oldVal.length) {
        this.activeItem = 0
      }
    },
    selectItem(val) {
      if (val) {
        this.$emit('select-hash-tag', this.filteredTag[this.activeItem])
        this.$nextTick(() => {
          this.$emit('update:filteredTag', [])
        })
      }
    },
    activeLeftOrRight() {
      if (!this.tabs || !this.tabs.length) { return }
      const currentTab = this.tabs.find(i => i.key === this.type)

      if (currentTab) {
        if (this.activeLeftOrRight > 0 && currentTab.sort === this.tabs.length) {
          this.changeType(this.tabs[0])
        } else if (this.activeLeftOrRight < 0 && currentTab.sort === 0) {
          this.changeType(this.tabs[this.tabs.length])
        } else {
          this.changeType(this.tabs.find(i => i.sort === currentTab.sort + this.activeLeftOrRight))
        }
      }
      this.$emit('activate-item')
    },
    activeUpOrDown() {
      if (
        this.activeUpOrDown > 0 &&
				this.activeItem < this.filteredTag.length - 1
      ) {
        this.activeItem++
      } else if (this.activeUpOrDown < 0 && this.activeItem > 0) {
        this.activeItem--
      }
      const activeITem = document.getElementsByClassName('hash-tag active')
      if (activeITem?.length) {
        activeITem[0].scrollIntoView({block: 'center', behavior: 'smooth'})
      }
      this.$emit('activate-item')
    },
    type(val, oldVal) {
      if (!oldVal || val !== oldVal) {
        this.activeItem = 0
      }
    },
  },
  filters: {
    firstUpperCase(val) {
      return val[0].toUpperCase() + val.slice(1)
    }
  },
}
</script>
<style scoped lang="scss">
.hash-tag {
  display: flex;
  flex-wrap: nowrap;
  padding: 6px;
  transition: 0.25s;
  cursor: pointer;
  &.active,
  &:hover,
  &:focus {
    background: var(--color-main-green);
  }
  &__name {
    font-size: 14px;
    line-height: 18px;
    margin: 6px;
    display: flex;
    text-align: left;
    white-space: nowrap;
    color: var(--black-color);
  }
}
.tag-hash {
  &__container {
    padding: 2px 0;
    width: 345px;
    height: 228px;
    overflow: auto;
    bottom: 86px;
    right: 20px;
    background: var(--v-main__light_green-base);
    border-radius: 5px;
    z-index: 2;
    border: 2px solid var(--color-main-green);
  }
  &__items {
    overflow: auto;
    max-height: calc(100% - 29px);
  }
  &__tabs {
    width: 100%;
    display: flex;
    border-bottom: 1px solid var(--color-main-green);
    padding: 2px 6px;
  }
  &__tab {
    padding: 0 5px;
    cursor: pointer;
    &.active {
      cursor: default;
      font-weight: 500;
      color: var(--black-color);
    }
  }
}
</style>
